<template>
  <div>
    <div class="bd-header bd-header_vesti">
      <div class="bd-header__menu" @click="shift()">
        <svg height="100" viewBox="-38 -38 100 100" width="100" xmlns="http://www.w3.org/2000/svg" v-if="!isMobile" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M-33-23h90c1.377 0 2.559.488 3.535 1.465S62-19.379 62-18s-.488 2.559-1.465 3.535S58.377-13 57-13h-90c-1.379 0-2.559-.488-3.535-1.465S-38-16.621-38-18s.488-2.559 1.465-3.535S-34.379-23-33-23zm0 60h90c1.377 0 2.559.488 3.535 1.465S62 40.623 62 42s-.488 2.559-1.465 3.535S58.377 47 57 47h-90c-1.379 0-2.559-.488-3.535-1.465S-38 43.377-38 42s.488-2.559 1.465-3.535S-34.379 37-33 37zm0-30h90c1.377 0 2.559.488 3.535 1.465S62 10.621 62 12s-.488 2.559-1.465 3.535S58.377 17 57 17h-90c-1.379 0-2.559-.488-3.535-1.465S-38 13.379-38 12s.488-2.559 1.465-3.535S-34.379 7-33 7z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.5 102.7" v-else="" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M47.6 98.1c2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6L29.4 58.7h83.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5H29.4l28.8-28.8c2.9-2.9 2.9-7.7 0-10.6C56.7 2.8 54.8 2 52.9 2s-3.8.7-5.3 2.2L6 45.8c-1.4 1.4-2.2 3.3-2.2 5.3S4.6 55 6 56.4l41.6 41.7z"/></svg>
      </div>
      <div class="bd-header__title bd-ht">
        <img class="bd-ht__img" src="/pages/vesti/img/logo.png" alt="">
      </div>
    </div>
    <div class="bd-vesti">
      <div class="bd-vesti-baner">
        <img class="bd-vesti-baner__img" src="/pages/vesti/img/baner0.jpg" alt="">
        <div class="bd-vesti-baner__footer">
          <div class="bd-vesti-baner__f-video">Смотреть видео</div>
          <div class="bd-vesti-baner__f-title">Владимир Путин: мы сами кого надо можем поучить</div>
          <div class="bd-vesti-baner__f-date">14:35 Сегодня</div>
        </div>
        <buzzCode @ready="ready" :id="id"></buzzCode>
      </div>
      <div class="bd-vesti-img-news">
        <div
          v-for='item in pageData.imgNews'
          :key='item.title'>
          <div class="bd-vesti-img-news__item bd-vesti-in">
            <img :src="item.img" alt="" class="bd-vesti-in__img">
            <div class="bd-vesti-in__title">{{ item.title }}</div>
            <div class="bd-vesti-in__date">12:05 Сегодня</div>
          </div>
        </div>
      </div>
      <div class="bd-vesti-text-news">
        <div class="bd-vesti-text-news__title">Сегодня</div>
        <div
          v-for='item in pageData.textNews'
          :key='item.title'>
          <div class="bd-vesti-text-news__item bd-vesti-tn">
            <div class="bd-vesti-tn__title">{{ item.title }}</div>
            <div class="bd-vesti-tn__date">43 минуты назад</div>
          </div>
        </div>
      </div>
      <div class="bd-vesti-footer">
        <div class="bd-vesti-footer__item">Программы</div>
        <div class="bd-vesti-footer__item">Реклама на сайте</div>
        <div class="bd-vesti-footer__item">Оповещения vesti.ru</div>
      </div>
    </div>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'vesti',
  data() {
    return {
      pageData: {
        imgNews: [
          {
            title: 'Из-за украинских стрельб авиакомпании удлинили маршруты',
            img: '/pages/vesti/img/1.jpg',
          },
          {
            title: 'Норвежский мат: корона осталась у Карлсена',
            img: '/pages/vesti/img/2.jpg',
          },
          {
            title: 'Сбили двух пешеходов: электрички Ярославского и Казанского направления задерживаются',
            img: '/pages/vesti/img/3.jpg',
          },
          {
            title: 'Недозаправка: названа причина авиакатастрофы под Медельином',
            img: '/pages/vesti/img/4.jpg',
          },
        ],
        textNews: [
          {
            title: 'Дерево, упавшее на востоке Москвы, убило женщину',
          },
          {
            title: 'Ежегодное Послание президента РФ Федеральному Собранию. Сурдоперевод',
          },
          {
            title: 'В России запустят единый транспондер для всех платных дорог',
          },
          {
            title: 'Истребитель с отказавшим двигателем аварийно сел в Перми',
          },
          {
            title: 'Что соглашение ОПЕК означает для всего мира',
          },
          {
            title: 'Нужна помощь: Егора Молокова спасут расходные материалы для диализа',
          },
          {
            title: 'Сбили двух пешеходов: электрички Ярославского и Казанского направления задерживаются',
          },
          {
            title: 'В Москве задержаны трое полицейских, подозреваемых в похищении',
          },
          {
            title: 'Обзор смартфона Sony Xperia X Compact: малыш почти без компромиссов',
          },
          {
            title: 'В Америке чистят снег "дрифтующими" грузовиками',
          },
          {
            title: 'Канье Уэст вышел из больницы после нервного срыва',
          },
          {
            title: 'BMW отзывает на ремонт более 30 тысяч российских кроссоверов',
          },
          {
            title: 'Gooligan заразил свыше миллиона Android-смартфонов',
          },
          {
            title: '"Одиссея": приключенческий фильм о великом капитане Кусто вышел в российский прокат',
          },
          {
            title: 'Уральский полицейский из-за ревности убил врача, а потом покончил с собой',
          },
          {
            title: 'Рейтинг лучших вузов БРИКС: университеты России укрепляют свои позиции',
          },
        ],
      },
      isMobile,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
    shift() {
      if (isMobile) {
        this.$emit('shift');
      }
    },
  },
};
</script>

<style scoped lang='stylus'>

fontSize(size, lineHeight)
  font-size ((size*0.0625)rem)
  line-height ((lineHeight/size)em)

img
  display block
  width 100%
  height auto
.bd
  &-header
    transition margin .4s
    display flex
    flex-flow row nowrap
    position fixed
    z-index 99997
    align-items center
    align-content space-around
    width 100%
    height 60px
    &_hide
      margin-top -60px
    &__menu
      width 30px
      height 20px
      margin 15px
      svg
        width 100%
        height 100%
        display block
    &__title
      width 100%
      text-align center
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
  &-header
    &_vesti
      align-items flex-end
      background-color #0095da
      & ^[1]__menu
        fill white
      .bd-ht__img
        display block
        width auto
        height 50px
        margin 0 auto
    &__menu
      -webkit-tap-highlight-color transparent
      outline none
  &-svg-icon
    -webkit-tap-highlight-color transparent
    outline none
  &-vesti
    text-align left
    &-baner
      background-color #333
      &__img
        display block
        width 100%
        height auto
      &__footer
        height 72px
      &__f
        &-video
          position absolute
          width 96px
          height 24px
          margin-top -24px
          padding-top 72px
          background url('/pages/vesti/img/play_btn.png') no-repeat 100% 80% #0095da
          background-size 80% auto
          font-family 'Roboto Condensed', sans-serif
          fontSize(12,12)
          font-weight 700
          text-align center
          color white
        &-title
          padding 10px 0 0 110px
          font-family Arimo, sans-serif
          fontSize(16,14)
          color white
        &-date
          padding-left 110px
          font-family 'Roboto', sans-serif
          fontSize(11,20)
          color #999
    &-img-news
      background-color #333
      &__item
        border-top 1px solid #444
        border-left 3px solid #215278
        &:last-child
          border-bottom 1px solid #444
    &-in
      min-height 76px
      padding 10px 6px
      &__img
        position absolute
        right 10px
        display block
        width 126px
        height auto
      &__title
        height 54px
        padding-right 140px
        font-family 'Arimo', sans-serif
        fontSize(13,18)
        color white
        overflow-y hidden
      &__date
        padding-right 140px
        font-family 'Roboto', sans-serif
        fontSize(11,20)
        color #999
    &-text-news
      &__title
        padding 0 12px
        border-bottom 1px solid #ccc
        font-family 'PT Sans', sans-serif
        fontSize(14,55)
        font-weight 700
        text-transform uppercase
      &__item
        padding 12px
        border-bottom 1px solid #ccc
    &-tn
      &__title
        font-family 'Arimo', sans-serif
        fontSize(14,18)
      &__date
        padding-top 24px
        font-family 'Roboto', sans-serif
        fontSize(11,20)
        color #999
    &-footer
      border-top 9px solid #2483c5
      background-color #333
      &__item
        padding 30px 24px
        border-bottom 1px solid #484848
        font-family 'PT Sans', sans-serif
        fontSize(18,24)
        color #555
</style>
